import React from 'react';
import cn from 'classnames';
import { IIcon, useIconProps } from '../useIconProps';
import InfoSvgIcon from './info.svgrIcon.svg';
import styles from './styles.module.scss';

interface IInfoIcon extends IIcon {
  iconFill?: 'transparent' | 'currentColor';
}

export const InfoIcon = React.forwardRef(({ iconFill = 'transparent', className, ...props }: IInfoIcon, ref) => {
  const iconProps = useIconProps({
    ref,
    size: 20,
    className: cn(className, iconFill === 'currentColor' && styles.infoIcon),
    ...props,
  });

  return <InfoSvgIcon {...iconProps} />;
});
